<ul class="alarm-row text">
    <li class="td th-no">{{ index }}</li>
    <li class="td">
        {{
            userNamePrefix.concat(".", operation.user.userRole.role) | translate
        }}
    </li>
    <li class="td fill-half">{{ operation.id }}</li>
    <li class="td">{{ operation.name }}</li>
    <li class="td center">{{ operation.status }}</li>
    <li class="td center action">
        {{ operation.before }}
        <span class="arrow">&#8594;</span>
        {{ operation.after }}
    </li>
    <li class="td">
        <div>{{ operation.datetime }}</div>
    </li>
    <li
        class="td fill-half"
        style="padding-left: 10px; display: flex; justify-content: end"
    ></li>
</ul>
